export default __webpack_public_path__ + "static/media/about-ingame.f813dc80.svg";